export class DistrictResult {
    public id: number = 0;
    public name: string = '';
    public provinceId: number = 0;
    public provinceName: string = '';
    public countryId: number = 0;
    public countryName: string = '';
}
